
/**
 * @constructor
 */
export class NewSheetForFeedsContainerController {

  constructor() {
  }

  containerClasses = {
    'loading': true,
  };
  isDisabled = false;
  isActive = true;
  isCollapsed = true;
  showHelpLinks = true;
  isActionButtonDisabled = false;

  _updateDisabled() {
    this.showHelpLinks = !this.isDisabled;
    this.isActionButtonDisabled = this.isDisabled;
  }

  toggleCollapseClick() {
    this.containerClasses.loading = false;
    this.isCollapsed = !this.isCollapsed;
  }

  $onInit() {
    if (this.isCollapsed == undefined) {
      this.isCollapsed = true;
    }

    this._updateDisabled();
  }

  $onChanges(changes) {
    this._updateDisabled();
  }
}

// @ts-ignore
import html from './new-sheet-for-feeds.template.html';

export default {
  template: html,
  controller: NewSheetForFeedsContainerController,
  bindings: {
    isCollapsed: "<",
    isDisabled: "<"
  }
};